import { AgentPortal } from '@wallet-manager/pfh-pmp-node-def-types';

import axios from '../axiosInstance';
import { IOverviewResponse } from '../types';

const get = async (config?: any) => {
  const input = {
    ...config,
  };

  return await axios.get<any, IOverviewResponse>(
    AgentPortal.EptDashboard.dashboard.overview,
    input
  );
};

export default { get };
